import { useEffect, useState } from 'react';
import { toast } from 'sonner';

import { useAppDispatch, useAppSelector } from '@/features';
import { changeSheet } from '@/features/slice/event/event-slice';
import { useGetResourceQuery } from '@/features/slice/users';
import { useCreateRolePermissionsMutation } from '@/features/slice/users/roles.permission/role-permission-api-slice';

export type PermissionType = {
    create: boolean;
    read: boolean;
    update: boolean;
    delete: boolean;
};

type PermissionsState = {
    [resourceName: string]: PermissionType;
};
export const useCreateRolePermission = () => {
    const [roleName, setRoleName] = useState('');
    const [permissions, setPermissions] = useState<PermissionsState>({});
    const [
        createRolePermissions,
        { isLoading: roleloading, error: roleError },
    ] = useCreateRolePermissionsMutation();
    const { data: resourceData, isLoading: resourceLoading } =
        useGetResourceQuery('resource');
    const dispatch = useAppDispatch();
    const { sheetStatus } = useAppSelector((state) => state.eventSlice);
    const handleSubmit = async () => {
        const role = {
            name: roleName,
            description: 'Manages reports and stocks',
            permissions,
        };
        try {
            const roleResponse = await createRolePermissions(role);
            if (roleResponse.data.message) {
                toast.success(
                    'You have successfully added a new role with permission.',
                );
                dispatch(changeSheet(!sheetStatus));
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        if (resourceData?.data) {
            const initialPermissions: PermissionsState = {};
            resourceData.data.forEach((resource: any) => {
                initialPermissions[resource.name] = {
                    create: false,
                    read: false,
                    update: false,
                    delete: false,
                };
            });
            setPermissions(initialPermissions);
        }
    }, [resourceData]);

    const handleCheckboxChange = (
        resource: string,
        permission: keyof PermissionType,
        value: boolean | string,
    ) => {
        setPermissions((prevPermissions) => ({
            ...prevPermissions,
            [resource]: {
                ...prevPermissions[resource],
                [permission]: value,
            },
        }));
    };

    return {
        resourceLoading,
        roleloading,
        resourceData,
        handleSubmit,
        roleName,
        setRoleName,
        setPermissions,
        permissions,
        handleCheckboxChange,
        roleError,
    };
};
